"use strict";
var import_platform = require("@hcengineering/platform");
var import_forms = require("@hcengineering/forms");
var import_lang = require("./lang");
(0, import_platform.addStringsLoader)(import_forms.formsId, import_lang.loadLang);
//# sourceMappingURL=index.js.map
